module.exports = __webpack_public_path__ + "images/petal2.fd5d5fe6.webp";